import { render, staticRenderFns } from "./DialogPhotoView.vue?vue&type=template&id=22fe87f2"
import script from "./DialogPhotoView.vue?vue&type=script&lang=js"
export * from "./DialogPhotoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports